import { Route } from '@angular/router';
import { devices } from './devices';
import { locations } from './locations';
import { pools } from './pools';
import { SbIcons } from '@ngx-seatback/icons';
import { RoutingID } from '../../../sb-routing-enum';
import { tracker } from './tracker';

export const infrastructure: Route = {
  path: 'infrastructure',
  title: 'nav.infrastructure',
  data: {
    icon: SbIcons.networkInfrastructure,
    breadcrumb: 'nav.infrastructure',
  },
  children: [
    {
      path: '',
      redirectTo: RoutingID.devices,
      pathMatch: 'full',
      data: {
        breadcrumb: '',
      },
    },
    devices,
    locations,
    pools,
    tracker,
  ],
};
